import { lazy } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import PostHogPageView from "./components/PostHogPageView";
import { CarsProvider } from "@/context/CarsContext";
import LazyLoad from "./components/LazyLoad";

// Lazy load pages
const Index = lazy(() => import("./pages/Index"));
const Contact = lazy(() => import("./pages/Contact"));
const NotFound = lazy(() => import("./pages/NotFound"));
const CarDetail = lazy(() => import("./pages/CarDetail"));
const TradeIn = lazy(() => import("./pages/TradeIn"));
const CarSearch = lazy(() => import("./pages/CarSearch"));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const App = () => (
  <CarsProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <PostHogPageView />
          <Routes>
            <Route path="/" element={<LazyLoad><Index /></LazyLoad>} />
            <Route path="/kontakt" element={<LazyLoad><Contact /></LazyLoad>} />
            <Route path="/bil/:id" element={<LazyLoad><CarDetail /></LazyLoad>} />
            <Route path="/innbytte" element={<LazyLoad><TradeIn /></LazyLoad>} />
            <Route path="/biler" element={<LazyLoad><CarSearch /></LazyLoad>} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<LazyLoad><NotFound /></LazyLoad>} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </CarsProvider>
);

export default App;
